import {action, observable, makeObservable} from 'mobx';

class ForgotWorkspacePasswordDialog {
  @observable
  opened = false;

  @action
  openDialog = () => {
    this.opened = true;
  };

  @action
  closeDialog = () => {
    this.opened = false;
  };

  setStore = store => {
    this.store = store;
  };

  constructor() {
    makeObservable(this);
  }
}
export default ForgotWorkspacePasswordDialog;
